var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardFuelType4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 99,
    viewBox: "0 0 96 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2514",
    "data-name": "Rechteck 2514",
    width: 72,
    height: 72,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Komponente_53_3",
    "data-name": "Komponente 53 \\u2013 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 49.5,
    rx: 48,
    ry: 49.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48,
    cy: 49.5,
    rx: 47,
    ry: 48.5,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon--fernwaerme",
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3303",
    "data-name": "Gruppe 3303",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5841",
    "data-name": "Pfad 5841",
    d: "M43.619,56.5h9.788a1.251,1.251,0,0,0,1.251-1.251V20.162",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5842",
    "data-name": "Pfad 5842",
    d: "M5.416,56.5A1.19,1.19,0,0,1,4.29,54.882a5.222,5.222,0,0,1,3.883-3.063,1.218,1.218,0,0,0,.99-1,5.22,5.22,0,0,1,9.611-1.771,1.174,1.174,0,0,0,1.532.427,5.213,5.213,0,0,1,5.506.534s2.778,1.819,2.778,6.5Z",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5843",
    "data-name": "Pfad 5843",
    d: "M7.077,29.078,35.159,4.313a1.25,1.25,0,0,1,1.654,0L64.894,29.078",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_546",
    "data-name": "Linie 546",
    y1: 26.607,
    transform: "translate(17.314 20.162)",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5844",
    "data-name": "Pfad 5844",
    d: "M54.658,49.3A5.416,5.416,0,0,1,57.1,50.58a1.213,1.213,0,0,0,1.625-.011,5.431,5.431,0,0,1,9.01,3.143,5.527,5.527,0,0,1-.007,1.8A1.231,1.231,0,0,1,66.5,56.5H54.191",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5845",
    "data-name": "Pfad 5845",
    d: "M37.24,42.973a11.864,11.864,0,0,1-2.029-6.366c.144-4.473,2.788-4.388,2.932-8.862a11.694,11.694,0,0,0-2-6.273",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5846",
    "data-name": "Pfad 5846",
    d: "M46.286,42.973a11.864,11.864,0,0,1-2.029-6.366c.144-4.473,2.788-4.388,2.932-8.862a11.694,11.694,0,0,0-2-6.273",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5847",
    "data-name": "Pfad 5847",
    d: "M28.193,42.973a11.864,11.864,0,0,1-2.029-6.366c.144-4.473,2.788-4.388,2.932-8.862a11.694,11.694,0,0,0-2-6.273",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_547",
    "data-name": "Linie 547",
    x1: 64.398,
    transform: "translate(4 67.398)",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_548",
    "data-name": "Linie 548",
    y2: 17.245,
    transform: "translate(36 50.154)",
    fill: "none",
    stroke: "#004a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFuelType4);
export default __webpack_public_path__ + "static/media/dashboard-fuel-type-4.b2191622621b0b7d6f12391a4059d96a.svg";
export { ForwardRef as ReactComponent };